import ReactMounter from 'lib/ReactMounter';
import ProjectsPage from 'pages/ProjectsPage/ProjectsPage';

ReactMounter.registerComponentToMountOnLoad('ProjectsPage', ProjectsPage);
